import { Square2StackIcon } from '@heroicons/react/24/solid'

import type { ReactElement } from 'react'

export const REDUCER_INDEX = 'matches_v2'

export const BASE_URL = '/sports/soccer/matches'

export const EventType = {
  CARD_BLUE: 'CARD_BLUE',
  CARD_GREEN: 'CARD_GREEN',
  CARD_RED: 'CARD_RED',
  CARD_RED_DIRECT: 'CARD_RED_DIRECT',
  CARD_YELLOW: 'CARD_YELLOW',
  GOAL: 'GOAL',
  GOAL_AUTO: 'GOAL_AUTO',
  GOAL_HEAD: 'GOAL_HEAD',
  GOAL_PENAL: 'GOAL_PENAL',
  GOAL_SHOT: 'GOAL_SHOT',
  MATCH_END: 'MATCH_END',
  MATCH_START: 'MATCH_START',
  PENAL_DEFINITION: 'PENAL_DEFINITION',
  W: 'W',
} as const

export type EventType = (typeof EventType)[keyof typeof EventType]

export const EVENT_TYPES: { [key in EventType]: { description?: string; icon?: ReactElement; name: string } } = {
  [EventType.CARD_BLUE]: {
    description: 'Expulsión temporal con/sin sustitución',
    icon: <Square2StackIcon className="size-4 rounded text-blue" />,
    name: 'Tarjeta azul',
  },
  [EventType.CARD_GREEN]: {
    description: 'Tarjeta positiva que representa el juego limpio',
    icon: <Square2StackIcon className="size-4 rounded text-green" />,
    name: 'Tarjeta verde',
  },
  [EventType.CARD_RED]: {
    description: 'Expulsión permanente sin sustitución',
    icon: <Square2StackIcon className="size-4 rounded text-red" />,
    name: 'Tarjeta roja',
  },
  [EventType.CARD_RED_DIRECT]: {
    description: 'Expulsión permanente sin sustitución',
    icon: <Square2StackIcon className="size-4 rounded text-red border border-red" />,
    name: 'Tarjeta roja directa',
  },
  [EventType.CARD_YELLOW]: {
    description: 'Advertencia por falta o actitud antideportiva',
    icon: <Square2StackIcon className="size-4 rounded text-yellow" />,
    name: 'Tarjeta amarilla',
  },
  [EventType.GOAL]: { name: 'Gol' },
  [EventType.GOAL_AUTO]: { name: 'Auto-gol' },
  [EventType.GOAL_HEAD]: { name: 'Gol de cabeza' },
  [EventType.GOAL_PENAL]: { name: 'Gol en penalti' },
  [EventType.GOAL_SHOT]: { name: 'Gol de tiro libre' },
  [EventType.MATCH_END]: { name: 'Final de partido' },
  [EventType.MATCH_START]: { name: 'Inicio de partido' },
  [EventType.PENAL_DEFINITION]: { name: 'Definición por penales' },
  [EventType.W]: { name: 'W' },
}

export enum Sources {
  'approve' = 'approve',
  'console' = 'console',
  'disapprove' = 'disapprove',
  'report - confirm' = 'report - confirm',
  'report - deny' = 'report - deny',
}

export const SOURCE_NAMES: { [key in Sources]: string } = {
  [Sources.approve]: 'Encuentro cerrado',
  [Sources.console]: 'Procesamiento',
  [Sources.disapprove]: 'Encuentro abierto',
  [Sources['report - confirm']]: 'Reporte',
  [Sources['report - deny']]: 'Reporte rechazado',
}
